import { useState } from 'react'
import { useOutsideClick } from '../hooks/useOutsideClick'

// Column-visibility dropdown, paired with useColumnPrefs. Controlled open
// state so it works by keyboard (real button + aria-expanded) and stays open
// while toggling checkboxes.
export default function ColumnsMenu({ options, columns, onToggle, onReset, isDefault }) {
  const [open, setOpen] = useState(false)
  const ref = useOutsideClick(() => setOpen(false), open)

  return (
    <div className={`dropdown dropdown-end ${open ? 'dropdown-open' : ''}`} ref={ref}>
      <button
        type="button"
        className="btn btn-sm btn-outline"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        Columns
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <ul className="dropdown-content menu bg-base-200 rounded-box z-10 w-52 p-2 shadow-lg">
        {options.map(col => (
          <li key={col.key}>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                className="checkbox checkbox-sm"
                checked={columns[col.key]}
                onChange={() => onToggle(col.key)}
              />
              {col.label}
            </label>
          </li>
        ))}
        <li className="menu-title pt-1">
          <button
            type="button"
            className="btn btn-xs btn-ghost justify-start"
            onClick={onReset}
            disabled={isDefault}
          >
            Reset to default
          </button>
        </li>
      </ul>
    </div>
  )
}
